import { getCanChiYear } from '../core/canchi_year.js';

export function buildTieuVan({ startYear, count = 12 } = {}) {
  const years = [];

  for (let i = 0; i < count; i += 1) {
    const year = startYear + i;
    years.push({
      year,
      canChi: getCanChiYear(year)
    });
  }

  return years;
}
